import axios from "axios";

import { ENDPOINT } from "../../constant/environment";
import { decryptData, encryptData, getHeaderConfig } from "../../utils/api/encryption";
import { consoleLog } from "../../utils/consoleLog/consoleLog";
import { hasUsableJWT } from "../../utils/authentication/hasUsableJWT";

export async function saveFeedbackAPI(accessJWT: string, payload: any) {
  const URL = `${ENDPOINT}/app/v1/feedback`;
  let config = getHeaderConfig(null, accessJWT);
  if (!hasUsableJWT(accessJWT, "saveFeedbackAPI")) return null;
  try {
    consoleLog(["Feedback saved PAYLOAD", payload]);
    let response: any = await axios.post(URL, encryptData(payload), config);
    consoleLog(["Feedback saved RESPONSE", response]);
    if (response?.data) {
      const decryptedData = decryptData(response?.data);
      return decryptedData ? JSON.parse(decryptedData) : null;
    } else return null;
  } catch (error) {}
}
